module.exports = __webpack_public_path__ + "img/paimai03.841b433b.jpg";